import { render, staticRenderFns } from "./UserSupportDataTable.vue?vue&type=template&id=d3de9b00&scoped=true"
import script from "./UserSupportDataTable.vue?vue&type=script&lang=js"
export * from "./UserSupportDataTable.vue?vue&type=script&lang=js"
import style0 from "./UserSupportDataTable.vue?vue&type=style&index=0&id=d3de9b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3de9b00",
  null
  
)

export default component.exports